module.exports = __webpack_public_path__ + "img/mercedes-benz-g-2022-1024x676.f882ed33.jpg";